import { render, staticRenderFns } from "./manorTchDaily.vue?vue&type=template&id=7819aba8&"
import script from "./manorTchDaily.vue?vue&type=script&lang=js&"
export * from "./manorTchDaily.vue?vue&type=script&lang=js&"
import style0 from "./manorTchDaily.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports